import { render, staticRenderFns } from "./remindDialogQCC.vue?vue&type=template&id=41967e7c&scoped=true&"
import script from "./remindDialogQCC.vue?vue&type=script&lang=js&"
export * from "./remindDialogQCC.vue?vue&type=script&lang=js&"
import style0 from "./remindDialogQCC.vue?vue&type=style&index=0&id=41967e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41967e7c",
  null
  
)

export default component.exports